import React, { useCallback, useMemo } from 'react';
import DropDown from '../dropdown';
import PropTypes from 'prop-types';
import { RoomTypes } from '../../../api/services/next';

const RoomTypesDropDown = ({ HotelIDs, search, ...rest }) => {

    const customSearch = useCallback((options, value) => {
        const lowerTrimmedValue = value.toLowerCase().trim();

        return options.filter(({ description, text, key }) => {
            return (
                key && // Don't return the "All" option when filtering
                (
                    text.toLowerCase().trim().includes(lowerTrimmedValue) ||
                    (description && description.toLowerCase().trim().includes(lowerTrimmedValue))
                )
            );
        });
    }, []);

    const memoizedSpec = useMemo(() => ({HotelIds: HotelIDs }),[HotelIDs])
    // Construct props conditionally based on whether `search` was provided
    const dropDownProps = useMemo(() => ({
        api: RoomTypes.GetRoomTypes,
        spec: memoizedSpec,
        textField: "Name",
        valueField: "Id",
        descriptionField: "ShortName",
        sort: (items) => items.sort((a, b) => a.DisplayOrder - b.DisplayOrder),
        ...(search && { search: customSearch }), // Conditionally include search prop
        ...rest,
    }), [ memoizedSpec, search, customSearch, rest]);

    return (
        <DropDown {...dropDownProps} />
    );
};

RoomTypesDropDown.propTypes = {
    HotelIDs: PropTypes.arrayOf(PropTypes.string.isRequired),
    search: PropTypes.any, // It's fine if this is undefined; customSearch handles it
};

export default RoomTypesDropDown;
